import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import CreateMoneyReceipt from "./CreateMoneyReceipt";
import MoneyReceiptTableRow from "./MoneyReceiptTableRow";
import type { IMoneyReceipt } from "./type/moneyReceiptType";

const MoneyReceipt = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});

	const [search, setSearch] = useState("");
	const [dateRange, setDateRange] = useState(undefined);
	const { data: moneyReceipt, isLoading } = useGetQueryWithTotal<
		IMoneyReceipt[]
	>({
		endPoint: "/api/admin/exhibitor/money-receipt",
		queryKeys: ["money-receipt"],
		params: { pagination, money_receipt_no: search, dateRange },
	});
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<CommCard
			helmetTitle={"BTTF - Account List"}
			headerTitle={`Money Receipt List (${moneyReceipt?.total})`}
			showButton
			showCardHeader
			handleBtnForModalFun={handleOpen}
			btnText='Create Money Receipt'
			showSearch
			handleSearchFun={(value) => setSearch(value)}
			showDateRange
			handleDateRange={(value) => setDateRange(value)}
		>
			<>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Date</TableCell>
								<TableCell>MoneyReceipt No.</TableCell>
								<TableCell>Account Type</TableCell>
								<TableCell>Total Amount</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : moneyReceipt?.data?.length > 0 ? (
							<TableBody>
								{moneyReceipt?.data?.map(
									(moneyRece: IMoneyReceipt, index) => {
										return (
											<MoneyReceiptTableRow
												key={moneyRece.id}
												account={moneyRece}
												serial={index + 1}
												paginationSkip={pagination.skip}
											/>
										);
									}
								)}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={moneyReceipt?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>

				<ModalsWrapper
					showModal={open}
					setShowModal={setOpen}
					modalData={{ title: "Create Money Receipt" }}
				>
					<CreateMoneyReceipt handleClose={handleClose} />
				</ModalsWrapper>
			</>
		</CommCard>
	);
};

export default MoneyReceipt;
